import axios from "axios";

export function findPlanosDescontos({concessionariaId}) {
  return axios.post('/api/simulacao', {
    concessionariaId
  }).then(data => data.data).catch(() => []);
}